import { IRatingItem } from 'api/resort/types';
import classNames from 'classnames';
import { ReactComponent as SvgLike } from 'public/assets/icons/like.svg';
import { ReactComponent as SvgDislike } from 'public/assets/icons/dislike.svg';
import styles from './styles.module.scss';

export const Review = ({
  review, className,
}: {
  review: IRatingItem,
  className?: string,
}) => (
  <div className={classNames(styles.wrapper, className)}>

    <div className={styles.headerName}>
      <span className={classNames('h3', styles.h3, styles.name)}>{`${review.firstName ?? ''} ${review.lastName ?? ''}`}</span>
    </div>
    {(review.translated?.review ?? '') !== '' ? review.translated?.review : review.review}
    <footer>
      <div className={styles.level}>
        {(review.translated?.pros ?? review.pros) && (
        <div className={styles.pros} title={review.translated?.pros ?? review.pros}>
          <SvgLike />
          <span className={styles.text}>
            {review.translated?.pros ?? review.pros}
          </span>
        </div>
        )}
        {(review.translated?.cons ?? review.cons) && (
        <div className={styles.cons}>
          <SvgDislike />
          <span className={styles.text} title={review.translated?.cons ?? review.cons}>
            {review.translated?.cons ?? review.cons}
          </span>
        </div>
        )}
      </div>
    </footer>
  </div>
);
